import { Component, inject, input, model, output } from '@angular/core';
import { QueueAlertsService } from '../services/queue-alerts.service';
import { routes } from '../../app.routes';
import { RoutesService } from '../../shared/services/routes.service';
import { AccessService } from '../../core/services/access.service';
import { QueueAlertArrayInterface } from '../interfaces/queue-alert.interface';
import { QueueAlert, QueueAlertArray } from '../models/queue-alert.model';
import { ResourceFormCardComponent } from '../../shared/components/resource-form-card/resource-form-card.component';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { ResourceButtonGroupComponent } from '../../shared/components/resource-button-group/resource-button-group.component';
import { TargetPeopleListComponent } from '../../target-people/target-people-list/target-people-list.component';
import { ButtonModule } from 'primeng/button';
import { TargetPeopleArray } from '../../target-people/models/target-people.model';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-queue-alerts-list',
  standalone: true,
  imports: [
    ResourceFormCardComponent,
    CommonModule,
    TableModule,
    ResourceButtonGroupComponent,
    TargetPeopleListComponent,
    ButtonModule,
  ],
  templateUrl: './queue-alerts-list.component.html',
  styleUrl: './queue-alerts-list.component.css',
})
export class QueueAlertsListComponent {
  protected service = inject(QueueAlertsService);
  protected RoutesService = inject(RoutesService);

  protected access = inject(AccessService).access;
  protected resource = this.service.resource?.toLowerCase();

  public loading = model<boolean>(false);

  public detailed = input<boolean>(true);

  protected value = this.service.queueAlerts;
  // protected copyValue!: QueueAlertArray
  protected expandedRows = {};

  public length = output<number>();

  ngOnInit(): void {
    this.service.title.update((value) => 'Lista de Alertas de Cola');
    this.service.get().subscribe((data) => {
      // console.log('Queue Alerts List: ', data)
      this.value.update((value) => {
        value = (data as QueueAlertArrayInterface).map(
          (value) => new QueueAlert(value),
        );
        // this.copyValue = value;
        console.log('Queue Alerts List: ', value);
        console.log('value ad List: ', value.length);
        this.length.emit(value.length);
        return value;
      });
    });
  }

  updateTargetPeople(value: TargetPeopleArray, id: string) {
    console.log(`queueAlertsID: ${id}`);
    console.log('updateTargetPeople: ', value);
    console.log('loading: ', this.loading())
    this.service.updateTargetPeople(id, value).pipe(
      finalize(() => this.loading.set(false)) // Se ejecuta SIEMPRE al terminar
    ).subscribe({
      next: (data) => {
        console.log('data: ', data);
        // this.copyValue = this.value();
      },
      error: (err) => {
        console.error('Error en la petición: ', err);
        // this.value.update((value) => {
        //   value = this.copyValue;
        //   return value;
        // });
      }
    });
  }
}
